import axios from "axios";
// import { API_URL } from "../../constants";
const API_URL = 'https://media.filmwings.com/';

export const GetAllPosts = async (offset, ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');
    console.log(offset);
    try {
        let res = await axios.get(API_URL + "posts/get_posts", {
            headers: {
                'Authorization': "Bearer " + token,
                'Accept': 'application/json; charset=UTF-8',
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}